import { render, staticRenderFns } from "./DadosColaboradorSeguranca.vue?vue&type=template&id=788c365a&scoped=true"
import script from "./DadosColaboradorSeguranca.vue?vue&type=script&lang=js"
export * from "./DadosColaboradorSeguranca.vue?vue&type=script&lang=js"
import style0 from "./DadosColaboradorSeguranca.vue?vue&type=style&index=0&id=788c365a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788c365a",
  null
  
)

export default component.exports